import authReducer from '../../../redux/auth/authReducer';
import privilegeReducer from '../../../redux/auth/privilegeReducer';
import pageCandidates from './pages/candidatesReducer';
import { jobEditCreateReducer } from './pages/Job/CreateEditReducer';
import { globalFilter } from './filter/reducer';

export const employerReducers = {
   authReducer,
   privilegeReducer,
   pageCandidates,
   jobEditCreateReducer,
   globalFilter,
};
